import React from 'react'
import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import { PrivateRoute, SignInCompletion } from '@emerald-works/react-auth'
import {
  I18nExample,
  FormExample,
  HomePage,
  SimpleReduxExample,
  AsyncReduxExample,
  CounterRequestResponseExample,
  CounterRequestResponseWithReduxExample,
  CounterRealtime,
  CounterRealtimeWithEffect,
  ChatExample,
  ChatContextReducer,
  StockTicker,
  StockTickerAdmin,
  TodoRealtime,
  DisconnectHandling
} from './pages'
import App from './App'

const PrivateRoutePage = () => {
  return (
    <div>
      This is a private route sample page
    </div>
  )
}

const ApplicationRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<App />}>
      <Route path='/' element={<HomePage />} />
      <Route path='/i18n-example' element={<I18nExample />} />
      <Route path='/form-example' element={<FormExample />} />
      <Route path='/simple-redux-example' element={<SimpleReduxExample />} />
      <Route path='/async-redux-example' element={<AsyncReduxExample />} />
      <Route path='/counter-request-response' element={<CounterRequestResponseExample />} />
      <Route path='/counter-request-response-redux' element={<CounterRequestResponseWithReduxExample />} />
      <Route path='/todo-realtime' element={<TodoRealtime />} />
      <Route path='/counter-realtime' element={<CounterRealtime />} />
      <Route path='/counter-realtime-side-effects' element={<CounterRealtimeWithEffect />} />
      <Route path='/chat' element={<ChatExample />} />
      <Route path='/chat-context-reducer' element={<ChatContextReducer />} />
      <Route path='/stock-ticker' element={<StockTicker />} />
      <Route path='/stock-ticker-admin' element={<StockTickerAdmin />} />
      <Route path='/disconnect-handling' element={<DisconnectHandling />} />
      <Route path='/private-route' element={<PrivateRoute element={<PrivateRoutePage />} />} />
      <Route path='/signin' element={<SignInCompletion />} />
    </Route>
  ), {
    future: {
      v7_relativeSplatPath: true,
      v7_partialHydration: true
    }
  }
)

export default ApplicationRoutes
